import request from '@/utils/request'

export function getDetailed(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}
